import ApiService from './api.service'


const EmployeeSerive = {

	//aviz uchun api begin
	getDepartmentsByEmployeeId(employeeId) {
		return ApiService.post('/employee/get-departments/by-employee-id/'+employeeId)
	},
	getByNoLinkedId(data) {
		return ApiService.post(`/employee/search/no_linked_id`, data)
	},
	hasAvizDocument(id) {
		return ApiService.get('/aviz/has-document/' + id)
	},
	createAviz(payload) {
		return ApiService.post('/aviz/create', payload)
	},
	editAviz(id, payload) {
		return ApiService.post('/aviz/update/' + id, payload)
	},
	getRegNumber(id) {
		return ApiService.get('/aviz/get/reg-number/' + parseInt(id))
	},
	//aviz uchun api end

	byDepartment: function (payload) {
		return ApiService.post(`/employee/by-department/${payload.id}`, payload.pageLimit);
	},
	getEmployeeIfHaveLogin:  function (id) {
		return  ApiService.get(`/employee/by-department/with-login/${id}`);
	},

	saveEmployee: function (newEmployee) {
		return ApiService.post(`/employee/add-or-update`, newEmployee);
	},

	deleteEmployee: function (employerId) {
		return ApiService.delete(`/employee/delete/${employerId}`)
	},
	search: (data) => {
		return ApiService.post(`employee/search`, data);
	},
	searchByDepsId: (data) => {
		return ApiService.post(`employee/search-byDepIds`, data);
	},

	searchEmployee: (keyword) => {
		return ApiService.get(`employee/any/list/${keyword}`);
	},
	getSellers(keyword) {
		return ApiService.get(`employee/list-by-position/SELLER?keyword=${keyword}`)
	},
	getByDepartmentSearch(searchForm) {
		return ApiService.post(`department/search-byname`, searchForm);
	}

};
export default EmployeeSerive
